<template>
    <div>
        <HeaderBar/>
        <div class="px-1 bg-white">
            <div class="infrastructureTitle mt-4 mr-2">Infraestructura</div>
            <div>
                <validation-observer ref="GanForm">
                    <b-form  @submit.prevent="">
                        <b-form-group label="Infraestructura" class="mt-1" label-for="infrastructure">
                            <validation-provider #default="{ errors }" name="Infraestructura" rules="required">
                                <b-form-select  v-model="infrastructures.type" :options="readyOptions" :values="readyOptions.value"  label="text"/>
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group label="Tiempo de construccion (meses)" label-for="constructionYear">
                            <validation-provider #default="{ errors }" name="Tiempo de construccion (meses)" rules="required">
                                <b-form-input id="constructionYear" v-model="infrastructures.construction_time" :state="errors.length > 0 ? false : null"
                                    name="constructionYear" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <b-form-group label="Costo Aproximado en condiciones actuales" label-for="approxCost">
                            <validation-provider #default="{ errors }" name="Costo Aproximado en condiciones actuales" rules="required">
                                <b-form-input id="approxCost" v-model="infrastructures.amount" :state="errors.length > 0 ? false : null"
                                    name="approxCost" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <!-- <b-form-group label="Ubicación de la finca" label-for="farmLocation">
                            <validation-provider #default="{ errors }" name="farmLocation" rules="required">
                                <b-form-input id="farmLocation" v-model="farmLocation" :state="errors.length > 0 ? false : null"
                                    name="farmLocation" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form-group>
                        <div class="d-flex justify-content-center">
                            <b-img src="@/assets/images/ganImage/datalogfarmmap.png"  />
                            </div> -->
                    
                        <div class="d-flex justify-content-center reportButton mt-1">
                            <b-button  class="bg-primary w-75" @click="addNewEquipment">
                                <div class="d-flex justify-content-center ">
                                    <div class="ml-2">Actualizar Infraestructura </div>
                                </div>
                            </b-button>
                        </div>
                    </b-form>
                </validation-observer>
            </div>
            <ControlMenu />
        </div>
    </div>
</template>
<script>
import {BForm, BFormGroup, BFormInput,BFormSelect, BButton, BImg} from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue';
import HeaderBar from '@/components/HeaderBar.vue'

import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations'
import vSelect from "vue-select";
export default {
    components: {
        BForm,
        BFormGroup,
        BFormInput,
        BButton,
        BFormSelect,
        BImg,
        vSelect,
        ControlMenu,
        HeaderBar,
        required,
        ValidationObserver,
        ValidationProvider,
    },
    data () {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        // 15th two months prior
        const minDate = new Date(today)
        minDate.setMonth(minDate.getMonth() - 500)
        minDate.setDate(15)
        // 15th in two months
        const maxDate = new Date(today)
        maxDate.setMonth
        maxDate.setMonth(maxDate.getMonth())
        maxDate.setDate(maxDate.getDate())
        return {
            maxCfgDate:maxDate,
            minCfgDate:minDate,
            farmLocation:'',
            readyOptions:[],
            infrastructure:'',
            constructionYear:'',
            approxCost:null,
            infrastructures:{
                farm_id:localStorage.getItem('currentFarm'),
                type:0,
                construction_time:0,
                amount:0
            }


        }
    },
    methods: {
        async fetchInfraestructureTypes(config){
            fetch(this.$apiUrl+"list/infrastructure_types", config)
            .then(response => response.json())
            .then(result => {
                console.log(result.infrastructure_types);
                this.readyOptions = result.infrastructure_types.map(item => {return {text:item.name,value:item.id }});
                console.log(this.readyOptions);
            })
        },
        async fetchInfraestructure(config){
            let idEq=parseInt(this.$route.params.id);
            fetch(this.$apiUrl+"view/infrastructures/"+idEq, config)
            .then(response => response.json())
            .then(result => {
                this.infrastructures= result.infrastructures;
            })
        },

        addNewEquipment() {
            this.$refs.GanForm.validate().then(success => {
                if(success){
                    let self=this;
                    let idEq=parseInt(this.$route.params.id);
                    const token = localStorage.getItem("accessToken");
                    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
                    this.$http.post("edit/infrastructures/"+idEq, this.infrastructures, config).then(()=>{
                        this.infrastructures={
                            farm_id:localStorage.getItem('currentFarm'),
                            type:0,
                            construction_time:0,
                            amount:0
                        }

                        this.$swal({
                            title: 'Registro de Infraestructura',
                            text: 'Se insertó infraestructura de manera satisfactoria',
                            type: 'success',
                            icon:'success',
                            showCancelButton: false,
                            confirmButtonColor:'#5E8F23',
                            showCloseButton: true,
                            showLoaderOnConfirm: false  
                        }).then(function(){
                            history.back();
                        });
                    }).catch(error => {
                        console.log(error)
                    });
                }
            })
            
        },
    },
    created() {
        const token = localStorage.getItem("accessToken");
        const config = {headers: {"X-Authorization": `Bearer ${token}`}};
        this.fetchInfraestructureTypes(config);
        this.fetchInfraestructure(config);
    }
}
</script>

<style>
.infrastructureTitle {
    font-weight: 600;
    font-size: 24px;
}
</style>